import React from 'react';
import type { FC } from 'react';

interface AllTemplatesIconProps {
    className?: string;
}

export const AllTemplatesIcon: FC<AllTemplatesIconProps> = ({ className }) => {
    return (
        <svg className={className} viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <title>All Templates Icon</title>
            <path
                d="M1 2.16732C1 1.9463 1.0878 1.73434 1.24408 1.57806C1.40036 1.42178 1.61232 1.33398 1.83333 1.33398H5.16667C5.38768 1.33398 5.59964 1.42178 5.75592 1.57806C5.9122 1.73434 6 1.9463 6 2.16732V5.50065C6 5.72166 5.9122 5.93363 5.75592 6.08991C5.59964 6.24619 5.38768 6.33398 5.16667 6.33398H1.83333C1.61232 6.33398 1.40036 6.24619 1.24408 6.08991C1.0878 5.93363 1 5.72166 1 5.50065V2.16732Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 2.16732C8 1.9463 8.0878 1.73434 8.24408 1.57806C8.40036 1.42178 8.61232 1.33398 8.83333 1.33398H12.1667C12.3877 1.33398 12.5996 1.42178 12.7559 1.57806C12.9122 1.73434 13 1.9463 13 2.16732V5.50065C13 5.72166 12.9122 5.93363 12.7559 6.08991C12.5996 6.24619 12.3877 6.33398 12.1667 6.33398H8.83333C8.61232 6.33398 8.40036 6.24619 8.24408 6.08991C8.0878 5.93363 8 5.72166 8 5.50065V2.16732Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1 10.4993C1 10.2783 1.0878 10.0664 1.24408 9.91009C1.40036 9.75381 1.61232 9.66602 1.83333 9.66602H5.16667C5.38768 9.66602 5.59964 9.75381 5.75592 9.91009C5.9122 10.0664 6 10.2783 6 10.4993V13.8327C6 14.0537 5.9122 14.2657 5.75592 14.4219C5.59964 14.5782 5.38768 14.666 5.16667 14.666H1.83333C1.61232 14.666 1.40036 14.5782 1.24408 14.4219C1.0878 14.2657 1 14.0537 1 13.8327V10.4993Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 10.4993C8 10.2783 8.0878 10.0664 8.24408 9.91009C8.40036 9.75381 8.61232 9.66602 8.83333 9.66602H12.1667C12.3877 9.66602 12.5996 9.75381 12.7559 9.91009C12.9122 10.0664 13 10.2783 13 10.4993V13.8327C13 14.0537 12.9122 14.2657 12.7559 14.4219C12.5996 14.5782 12.3877 14.666 12.1667 14.666H8.83333C8.61232 14.666 8.40036 14.5782 8.24408 14.4219C8.0878 14.2657 8 14.0537 8 13.8327V10.4993Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
